import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { router } from '@/app/router';
import { AuthProvider } from '@/auth/AuthProvider';
import { Mantenimiento } from '@/components/Mantenimiento';
import { Toaster } from '@/components/ui/toaster';
import { env } from '@/lib/env';
import { TemaProvider } from '@/lib/TemaProvider';

import './styles/index.css';

// Errores del navegador a Sentry (plan §18). Sin datos personales: sin IP ni cuerpos, y las URLs
// de media firmada (tokens) se recortan.
if (env.sentryDsn) {
  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.appEnv,
    beforeSend(event) {
      if (event.request?.url) event.request.url = event.request.url.split('?')[0] ?? '';
      if (event.user) event.user = event.user.id === undefined ? {} : { id: event.user.id };
      return event;
    },
    beforeBreadcrumb(b) {
      if (typeof b.data?.url === 'string')
        b.data.url = b.data.url.replace(/\/protected\/media\/[^/?]+/, '/protected/media/…');
      return b;
    },
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, err) => count < 2 && !(err instanceof Error && err.name === 'ApiError'),
      refetchOnWindowFocus: true,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Falta #root');

createRoot(root, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <TemaProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster />
          <Mantenimiento />
        </AuthProvider>
      </QueryClientProvider>
    </TemaProvider>
  </StrictMode>,
);
